<template>
  <div>
        <modal :modal-key="'prize-details_modal'"
               :class-style="'modal modal--prize-details'" :body-style="'welcome-pad'"
               @close="$emit('close')">
          <template slot="header">
          <h2 v-if="getShowmodalForDefaultPrizeDetails.type === 'DAILY'">
            {{ getTranslations.home_modals_prize_details_daily_prize }}</h2>
          <h2 v-if="getShowmodalForDefaultPrizeDetails.type === 'WEEKLY'">
            {{ getTranslations.home_modals_prize_details_weekly_prize }}</h2>
          <h2 v-if="getShowmodalForDefaultPrizeDetails.type === 'MONTHLY'">
            {{ getTranslations.home_modals_prize_details_monthly_prize }}</h2>
          <h2 v-if="getShowmodalForDefaultPrizeDetails.type === 'GRAND'">
            {{ getTranslations.home_modals_prize_details_grand_prize }}</h2>
          <h1 v-if="getShowmodalForDefaultPrizeDetails.type === 'DAILY'">
            {{ getShowmodalForDefaultPrizeDetails.activeFrom | getFormat }}</h1>
          <h1 v-else>{{ getShowmodalForDefaultPrizeDetails.activeFrom | getFormat
            }} - {{ getShowmodalForDefaultPrizeDetails.activeTo | getFormat }}</h1>
        </template>
          <template slot="body">
          <img :src="getShowmodalForDefaultPrizeDetails.imgUrl" alt="">
          <span class="prize-text">{{ getShowmodalForDefaultPrizeDetails.headline }}</span>
          <div class="modal-section">
            <h2 class="modal-section__title">{{ getTranslations.home_modals_prize_details_who_wins }}</h2>
            <div class="modal-section__body">
              <p>{{ getShowmodalForDefaultPrizeDetails.description }}</p>
            </div>
          </div>
          <div class="modal-section">
            <h2 class="modal-section__title">{{ getTranslations.home_modals_prize_details_eligibility }}</h2>
            <div class="modal-section__body">
              <p>{{ getShowmodalForDefaultPrizeDetails.eligibilityCriteria }}</p>
            </div>
          </div>
        </template>
    </modal>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';
import Modal from '@/components/home/modals/shared/GenericModal';

const moment = require('moment/moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'prize-details',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getShowmodalForDefaultPrizeDetails',
    ]),
  },
  filters: {
    getFormat(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/prizes/PrizeDetails.vue